import React from 'react';
import { FadeInSection } from './ui/FadeInSection';
import { CTAButton } from './ui/CTAButton';
import { Check, Lock, Smartphone, ShieldCheck } from 'lucide-react';
export function CloseAndFinalCTA() {
  return <>
      {/* SECTION 19 — EMOTIONAL CLOSE */}
      <section className="bg-chocolate px-4 py-20 md:py-32 text-center relative overflow-hidden" data-id="element-1">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-gold/5 via-chocolate to-chocolate pointer-events-none" data-id="element-2"></div>
        <div className="max-w-2xl mx-auto relative z-10" data-id="element-3">
          <FadeInSection data-id="element-4">
            <p className="text-2xl text-cream mb-8 font-heading italic" data-id="element-5">
              Llegaste hasta acá.
            </p>

            <div className="space-y-2 text-lg md:text-xl text-warmWhite/80 mb-12" data-id="element-6">
              <p data-id="element-7">Estás cansada del ciclo.</p>
              <p data-id="element-8">De privarte. De la culpa.</p>
              <p data-id="element-9">Del lunes que nunca llega.</p>
            </div>

            <div className="space-y-2 text-lg md:text-xl text-cream mb-12" data-id="element-10">
              <p data-id="element-11">El Método Antídoto no te pide que seas perfecta.</p>
              <p data-id="element-12">
                Te pide que le des una oportunidad a un Sistema que trabaja con
                tu biología y no en tu contra.
              </p>
            </div>

            <p className="text-2xl md:text-3xl text-gold font-heading italic mb-4" data-id="element-13">
              El dulce no es tu enemigo.
              <br data-id="element-14" />
              Nunca lo fue.
            </p>

            <p className="text-3xl md:text-4xl font-black text-gold uppercase tracking-wide mt-8" data-id="element-15">
              Solo necesitaba un ANTÍDOTO.
              <br data-id="element-16" />
              <span className="text-warmWhite text-2xl md:text-3xl mt-4 block" data-id="element-17">
                Y hoy ese Antídoto es tuyo.
              </span>
            </p>
          </FadeInSection>
        </div>
      </section>

      {/* SECTION 20 — FINAL CTA */}
      <section className="bg-cream px-4 py-16 md:py-24 border-t border-gold/30" data-id="element-18">
        <div className="max-w-4xl mx-auto" data-id="element-19">
          <FadeInSection data-id="element-20">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-21">
              {/* Card 1: Basic System */}
              <div className="bg-white rounded-3xl p-8 flex flex-col justify-between shadow-lg border border-chocolate/10" data-id="element-22">
                <div data-id="element-23">
                  <h3 className="text-2xl font-black text-chocolate mb-2" data-id="element-24">
                    SISTEMA COMPLETO
                  </h3>
                  <p className="text-chocolate-light font-medium mb-8" data-id="element-25">
                    5 Tomos + 5 Bonos | 500+ páginas
                  </p>
                </div>

                <div data-id="element-26">
                  <CTAButton className="w-full text-lg py-4 mb-6" data-id="element-27">
                    ACCEDER AHORA — $19.990
                  </CTAButton>
                  <ul className="space-y-2 text-sm font-medium text-textBody" data-id="element-28">
                    <li className="flex items-center gap-2 justify-center" data-id="element-29">
                      <Check className="w-4 h-4 text-success" data-id="element-30" /> Acceso
                      inmediato
                    </li>
                    <li className="flex items-center gap-2 justify-center" data-id="element-31">
                      <Check className="w-4 h-4 text-success" data-id="element-32" /> Garantía 7 días
                    </li>
                  </ul>
                </div>
              </div>

              {/* Card 2: Combo (Highlighted) */}
              <div className="bg-chocolate rounded-3xl p-8 flex flex-col justify-between border-2 border-gold shadow-gold relative transform md:-translate-y-4" data-id="element-33">
                <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold text-chocolate px-4 py-1 rounded-full text-sm font-bold whitespace-nowrap" data-id="element-34">
                  MÁS ELEGIDO
                </div>

                <div data-id="element-35">
                  <h3 className="text-2xl font-black text-gold mb-2 flex items-center gap-2" data-id="element-36">
                    <span data-id="element-37">⭐</span> COMBO COMPLETO
                  </h3>
                  <p className="text-cream font-medium mb-8" data-id="element-38">
                    Sistema + Protocolo Día Blindado
                  </p>
                </div>

                <div data-id="element-39">
                  <CTAButton className="w-full text-xl py-5 mb-6 shadow-gold" data-id="element-40">
                    ACCEDER AHORA — $29.990
                  </CTAButton>
                  <ul className="space-y-2 text-sm font-medium text-cream/90" data-id="element-41">
                    <li className="flex items-center gap-2 justify-center" data-id="element-42">
                      <Check className="w-4 h-4 text-gold" data-id="element-43" /> Plan 21 días
                      incluido
                    </li>
                    <li className="flex items-center gap-2 justify-center" data-id="element-44">
                      <Check className="w-4 h-4 text-gold" data-id="element-45" /> Resultados
                      acelerados
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Bottom Trust Badges */}
            <div className="flex flex-wrap justify-center gap-6 md:gap-12 text-chocolate font-medium" data-id="element-46">
              <div className="flex items-center gap-2" data-id="element-47">
                <Lock className="w-5 h-5 text-gold" data-id="element-48" /> Pago seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-49">
                <Smartphone className="w-5 h-5 text-gold" data-id="element-50" /> Acceso inmediato
              </div>
              <div className="flex items-center gap-2" data-id="element-51">
                <ShieldCheck className="w-5 h-5 text-gold" data-id="element-52" /> Garantía 7 días
              </div>
            </div>
          </FadeInSection>
        </div>
      </section>
    </>;
}